import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'
import ProductGalleryUI, {
  Props as UIProps,
} from '@interflora/ui-components/build/components/ProductGallery/ProductGallery'
import React, { useEffect, useRef, useState, useMemo } from 'react'
import SkeletonProductGallery from '@interflora/ui-components/build/components/SkeletonProductGallery/SkeletonProductGallery'
import { useRouter } from 'next/router'
import useStyles from '@interflora/ui-components/build/components/ProductGallery/ProductGallery.styles'
type Props = UIProps & {
  uiType?: string
  meta: {
    deliveryId: string
  }
}

const ProductGallery = (props: Props) => {
  const router = useRouter()
  const { classes } = useStyles()

  const isShowSkeleton = useMemo(() => {
    const path = router?.asPath
    if (!path) return false
    return (
      path === '/' ||
      path.includes('/category') ||
      path.includes('/flower-delivery') ||
      path.includes('/blog') ||
      path.includes('/page') ||
      path.includes('/search') ||
      path.includes('/nosearch')
    )
  }, [router?.asPath])

  const [showSkeleton, setShowSkeleton] = useState<boolean>(isShowSkeleton)
  const {
    meta: { deliveryId },
    uiType,
    products,
    linksAfter,
  } = props
  const keysRef = useRef<string | undefined>(undefined)

  useEffect(() => {
    const keys = (products ?? []).map((product) => product.key).join(',')
    if (keys !== keysRef.current) {
      keysRef.current = keys
    }
  }, [uiType, deliveryId, products])

  useLoaded(props)
  return (
    <div className={classes.productGallery}>
      {showSkeleton && (
        <SkeletonProductGallery
          productCount={(products?.length ?? 0) > 3 ? 3 : products?.length}
          showLinks={(linksAfter?.length ?? 0) > 0}
          galleryDisplayType={props.galleryDisplayType}
        />
      )}
      <ProductGalleryUI {...props} showSkeleton={showSkeleton} setShowSkeleton={setShowSkeleton} />
    </div>
  )
}

export default ProductGallery
